import { render, staticRenderFns } from "./Ot.vue?vue&type=template&id=09b36962"
import script from "./Ot.vue?vue&type=script&lang=js"
export * from "./Ot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports